import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Colors, GreyPallet } from "../../config/styles";

interface StyledChipProps {
  chipcolor: "direto" | "inverso" | "reitoria" | "cet" | string;
}

export const StyledChip = styled(Chip)<StyledChipProps>(({ chipcolor }) => ({
  backgroundColor:
    chipcolor === "direto"
      ? Colors.Direto
      : chipcolor === "inverso"
      ? Colors.Inverso
      : chipcolor === "reitoria"
      ? Colors.Reitoria
      : chipcolor === "cet"
      ? Colors.Cet
      : GreyPallet.Black,
  "& .MuiChip-label": {
    color: "white",
  },
}));

export const CustomBox = styled(Box)({
  marginBottom: 16,
  "& .MuiTypography-root": {
    fontWeight: "bold",
    color: GreyPallet.Regular,
  },
  color: GreyPallet.Black,
  "& .MuiFormControlLabel-root": {
    justifyContent: "space-between",
    marginLeft: 0,
  },
  backgroundColor: GreyPallet.LightGhost,
  borderRadius: "15px",
  padding: "8px 16px",
});
